import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';


import ScrollToTop from './components/pages/ScrollToTop';
import Home from './components/pages/Home';
import Header from './components/Header';
import Sonoco from './components/pages/Sonoco';
import About from './components/pages/About';
import Footer from './components/Footer';
import PVC from './components/pages/PVC';
import PVDC from './components/pages/PVDC';
import Aluminium from './components/pages/Aluminium';
import Caps from './components/pages/Caps';
import Medical_service from './components/pages/Medical_service';
import Contact from './components/pages/Contact';
import Home1 from './components/pages/Home1';
import API from './components/pages/API';
import Aboutus from './components/pages/Aboutus';
import Sourcing from './components/pages/Sourcing';
import Formulation from './components/pages/Formulation';
import Shipping from './components/pages/Shipping';
import Excipients from './components/pages/Excipients';
import Customise_solution from './components/pages/Customise_solution';
import Glass from './components/pages/Glass';
import Pharmaceutical_distribution from './components/pages/Pharmaceutical_distribution';
import Storage_pharma from './components/pages/StoragePharma';


function App() {
  return (
    <div className="App">
      
      <BrowserRouter>
      <ScrollToTop/>
      <Header />
      <Routes>
      <Route path="/" element={<Home/>}></Route>
      <Route path="/home1" element={<Home1/>}></Route>
      <Route path="/sonoco" element={<Sonoco/>}></Route>
      <Route path="/sonoco-thermosafe" element={<Sonoco/>}></Route>
      <Route path="/about-us" element={<Aboutus/>}></Route>
      <Route path="/products/pvc" element={<PVC/>}></Route>
      <Route path="/products/pvdc" element={<PVDC/>}></Route>
      <Route path="/products/aluminium" element={<Aluminium/>}></Route>
      <Route path="/products/caps" element={<Caps/>}></Route>
      <Route path="/products/api" element={<API/>}></Route>
      <Route path="/products/excipients" element={<Excipients/>}></Route>
      <Route path="/products/glass" element={<Glass/>}></Route>
      <Route path="/services/medical" element={<Medical_service/>}></Route>
      <Route path="/contact-us" element={<Contact/>}></Route>
      <Route path="/services/sourcing" element={<Sourcing/>}></Route>
      <Route path="/services/formulation" element={<Formulation/>}></Route>
      <Route path="/services/shipping-and-logistics" element={<Shipping/>}></Route>
      <Route path="/services/customise-packaging-solution" element={<Customise_solution/>}></Route>
      <Route path="/services/pharmaceutical-distribution" element={<Pharmaceutical_distribution/>}></Route>
      <Route path="/services/storage-pharma" element={<Storage_pharma/>}></Route>

      <Route path="/*" element={<Home/>}></Route>
      
      
      </Routes>
      <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
